import { Injectable } from '@angular/core';
import { Item, ItemModel, CrudService } from 'collection';
import { format } from 'date-fns';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

import { legacyParse, convertTokens } from '@date-fns/upgrade/v2';

@Injectable({
  providedIn: 'root'
})
export class HolidaysService {
  holidaysItem: ItemModel = new Item({
    api: this._crud.createEntity({ name: 'holidays' }),
    params: {
      sort: 'date',
      per_page: 100
    }
  });

  holidaysObject: { [key: string]: boolean } = {};

  holidaysMap: Map<string, { [key: string]: boolean }> = new Map();

  resetHolidays(): void {
    this.holidaysObject = {};
    this.holidaysMap = new Map();
    this.holidaysItem.clear();
  }

  getHolidays({ from, to }): Observable<{ [key: string]: boolean }> {
    if (!(from && to)) {
      return of(this.holidaysObject);
    }

    const selectedFromYear = format(legacyParse(from), convertTokens('YYYY'));
    const selectedToYear = format(legacyParse(to), convertTokens('YYYY'));

    return of(true).pipe(
      switchMap(() => {
        if (!this.holidaysMap.has(selectedFromYear)) {
          this.holidaysItem.setParams('year', selectedFromYear);
          return this.loadHolidays(selectedFromYear);
        } else {
          return of(this.holidaysObject);
        }
      }),
      switchMap(() => {
        if (!this.holidaysMap.has(selectedToYear)) {
          this.holidaysItem.setParams('year', selectedToYear);
          return this.loadHolidays(selectedToYear);
        } else {
          return of(this.holidaysObject);
        }
      })
    );
  }

  loadHolidays(year) {
    let holidaysObj = {};
    this.holidaysItem.setParams('year', year);

    if (this.holidaysItem.loading) {
      return of(this.holidaysObject);
    }

    return this.holidaysItem.load().pipe(
      take(1),
      map(() => {
        const items = this.holidaysItem.data;
        if (items?.length) {
          items.forEach((item) => {
            holidaysObj[item.date.iso] = true;
          });
        }

        this.holidaysMap.set(year, holidaysObj);

        return this.payloadHolidays();
      })
    );
  }

  payloadHolidays(): { [key: string]: boolean } {
    let holidays = {};

    this.holidaysMap.forEach((value, key) => {
      holidays = { ...holidays, ...value };
    });

    this.holidaysObject = { ...holidays };

    return this.holidaysObject;
  }

  constructor(private _crud: CrudService) {}
}
